/* global jQuery bodymovin qualys*/

(function ($) {

	"use strict";

	$(document).ready(function(){

		$(".js-hero-create-account").on("click", function(){
			$(".email-field-wrapper").hide();
			$(".marketo-form-wrapper").show();

			var emailAddress = $(this).parent().find(".hero-email").val();
			$("[name=Email]").val( emailAddress );
		});

	});

}(jQuery));


(function () {
	"use strict";

	function loadAnimation(selector, data) {
		return bodymovin.loadAnimation({
			container: document.querySelector(selector),
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: data
		});
	}

	var animation2 = loadAnimation('.ai-screenshot-animation', '/asset/data/apps/asset-inventory/ai-screenshots.json');
	animation2.play();

}());

// populate form with email address from URL
(function ($) {
	"use strict";

	$('[type="email"]').val(qualys.parseQueryString(window.location.search).email);

}(jQuery));